const STYLES = {
  gold: "bg-amber-400/20 text-amber-300 border-amber-400/40",
  silver: "bg-slate-300/20 text-slate-200 border-slate-300/40",
  bronze: "bg-orange-700/25 text-orange-300 border-orange-600/40",
};
const LABELS = { gold: "Gold", silver: "Silver", bronze: "Bronze" };

export const TierBadge = ({ tier, className = "", testid }) => {
  if (!tier || !STYLES[tier]) return null;
  return (
    <span data-testid={testid || `tier-badge-${tier}`}
      className={`inline-flex items-center text-[10px] font-extrabold uppercase tracking-wide px-1.5 py-0.5 rounded border ${STYLES[tier]} ${className}`}>
      {LABELS[tier]}
    </span>
  );
};
